module.exports = __webpack_public_path__ + "img/passenger-ship.b5a82216.png";